(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"]) return;
  try {
    
$(document).ready(function () {
// Show the first tab and hide the rest
  $('#tab-links li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tab-links li').click(function(){
    $('#tab-links li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });
});
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-brands-slider"] && !Shopify.designMode) return;
  try {
    
  new Splide( '.brands-new', {
    breakpoints: {
      perPage: 1
    }
  }).mount();

let elms = document.querySelectorAll( '.brands-new' );
if (elms.length > 0) {
  for (let i = 0; i < elms.length; i++) {
        new Splide( elms[i] ).mount();
  }                               
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-card-slider"] && !Shopify.designMode) return;
  try {
    

let elms = document.querySelectorAll( '.splide-slider' );
if (elms.length > 0) {
  for (let i = 0; i < elms.length; i++) {
          new Splide( elms[i] ).mount();
  }
 }
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-occasion-slider"] && !Shopify.designMode) return;
  try {
    

  let elms = document.querySelectorAll( '.occasion-slider' );
    if (elms.length > 0) {
      for (let i = 0; i < elms.length; i++) {
            new Splide( elms[i] ).mount();
            
      }
  }

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homeslider-section"] && !Shopify.designMode) return;
  try {
    

  let elms = document.querySelectorAll( '.fullscreen-slider' );
  if (elms.length > 0) {
    for (let i = 0; i < elms.length; i++) {
          new Splide( elms[i] ).mount();
    }
}
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-with-filter"] && !Shopify.designMode) return;
  try {
    
  $('.filter-category').change(function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  $('.filter-tag').change(function() {
    var url = $(this).val();
    if (url) {
      console.log(url);
      window.location = url;
    }
    return false;
  });

  } catch(e) { console.error(e); }
})();
})();
